import React from 'react';

import { ProjectTimeSpentForm } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/ProjectTimeSpentEditForm/ProjectTimeSpentForm';
import { Project, ProjectTimeSpentRecord } from '~/@views/UserView/ProjectPage/ProjectTimeSpent/types';
import { showCustomDialog } from '~/services/dialog';

export const showProjectTimeSpentDialog = (project: Project, timeSpent: ProjectTimeSpentRecord | null) =>
    showCustomDialog({
        render: closeDialog => <ProjectTimeSpentForm onClose={closeDialog} timeSpent={timeSpent} project={project} />,
    });
